import React, { useEffect, useRef, useState, useCallback } from "react";
import "./boxStyle.css";
import Image from "./Image";
import uploadImg from "@/assets/img/upload.png";
import { assetUrl } from "@/utils/assetUrl";

/** The local pick before upload: the data URL is kept in a one-element array, as before. */
export type LocalUploadImage = {
  secure_url?: (string | ArrayBuffer | null)[];
  filename?: string;
};

export type AddImageProps = {
  ImageUpload?: (img: LocalUploadImage) => void;
  hideLocalImg?: boolean;
};

const AddImage = ({
  ImageUpload = (_img: LocalUploadImage) => {},
  hideLocalImg = false,
}: AddImageProps) => {
  const [img, setImg] = useState<LocalUploadImage>({});
  const fileRef = useRef<HTMLInputElement>(null);

  const onFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const fileName = file.name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const nextImg: LocalUploadImage = {
        // keep array form to match existing behavior
        secure_url: [reader.result],
        filename: fileName,
      };
      setImg(nextImg);
      ImageUpload(nextImg);
    };
  }, [ImageUpload]);

  // mirror UNSAFE_componentWillReceiveProps: reset local preview when parent asks
  useEffect(() => {
    if (hideLocalImg) setImg({});
  }, [hideLocalImg]);

  return (
    <>
      <div className="col-auto box-upload">
        <img
          src={assetUrl(uploadImg)}
          alt="upload Picture"
        />

        {!img.secure_url ? (
          <h4 className="text-center text-primary">UPLOAD</h4>
        ) : (
          <h4 className="text-center text-danger">CHANGE</h4>
        )}

        <input
          ref={fileRef}
          id="Imgupload"
          type="file"
          name="Imgupload"
          accept=".jpg, .jpeg, .png"
          onChange={onFileChange}
        />
      </div>

      {/* String() of the one-element array is the data URL, the same <img src> React rendered from the array. */}
      {img.secure_url ? (
        <Image image={{ secure_url: String(img.secure_url), filename: img.filename }} noInformation />
      ) : null}
    </>
  );
};

export default AddImage;
